import React, { FC } from 'react';

import { CommonError } from 'src/components/common-error/common-error';
import { i18n } from 'src/i18n';
import { owlImageProps } from 'src/resources/images';

export const PageNoBroadband: FC = () => (
  <CommonError
    title={i18n.page.error.noBroadband.title}
    subtitle={[i18n.page.error.noBroadband.mainSubtitle, i18n.page.error.noBroadband.subtitle]}
    image={owlImageProps}
  />
);
